const Logger = {
  captureException(exception = '') {
    /* eslint-disable */
    console.warn("Logger - Caught exception: ", exception);
    /* eslint-enable */
  },
};

export default Logger;



/** WEBPACK FOOTER **
 ** core/client/rawr/utils/Logger.js
 **/